export default function(value, limit) {
  const val = value || 0;
  if (val >= limit) {
    return `${limit - 1}+`;
  }
  return val;
}
